import React from 'react';

export const LifestyleQuote = () => {
    return (
        <section className="w-full relative py-20 md:py-32 mb-24 overflow-hidden bg-white border-y-[1.5px] border-black">
            {/* Background Image - Brutalist Theme */}
            <div className="absolute inset-0 w-full h-full mix-blend-luminosity opacity-80">
                <img
                    src="https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&q=80&w=2000"
                    alt="Lifestyle Background"
                    className="w-full h-full object-cover object-center grayscale contrast-125 brightness-90"
                />
                {/* Harsh Overlay */}
                <div className="absolute inset-0 bg-white/30 backdrop-blur-[2px]"></div>
            </div>

            {/* Content Container */}
            <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-12 flex justify-center items-center h-full text-center">
                <h2 className="font-heading text-4xl md:text-5xl lg:text-7xl text-black font-black uppercase tracking-tighter leading-[0.9] max-w-6xl mx-auto mix-blend-darken drop-shadow-md">
                    "Threada is a fashion house delivering above-average quality and a wide variety of styles from emerging designers."
                </h2>
            </div>
        </section>
    );
};
